import { FC } from "react"
import { useTranslation } from "react-i18next"
import { getFuelLabel } from "utils/utils"

import Slider from "./Slider"

interface ISliderFuelProps {
    value: number | null
    defaultValue?: number | null
    disabled?: boolean
    onChange(value: number): void
    validationMessage?: string
}

const SliderFuel: FC<React.PropsWithChildren<ISliderFuelProps>> = ({
    value,
    defaultValue = null,
    disabled,
    onChange,
    validationMessage,
}) => {
    const { t } = useTranslation()
    const valueLabel = value === null ? "" : getFuelLabel(value)
    const defaultValueLabel = <div className="color-grey-500">{defaultValue === null ? "" : `${defaultValue}%`}</div>

    return (
        <Slider
            min={0}
            max={100}
            step={25}
            value={value}
            valueLabel={valueLabel}
            defaultValue={defaultValue}
            defaultValueLabel={defaultValueLabel}
            scaleItems={[
                { label: t('common.empty'), left: '0' },
                { label: "1/4", left: '25%' },
                { label: "1/2", left: '50%' },
                { label: "3/4", left: '75%' },
                { label: t('common.full'), right: '0' }
            ]}
            disabled={disabled}
            onChange={onChange}
            validationMessage={validationMessage}
        />
    )
}

export default SliderFuel
